import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { DecisionSource } from '@bpos/v1/over-ask';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { UserStateService } from '@frontend/sports/user/feature';
import { Store, createSelector } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { IBetslipRootState } from '../../../base/store/state';
import { OverAskFlowState } from '../../../model/over-ask/over-ask';
import { IBetslipOverAskPickListProps, IBetslipOverAskSummaryComponentProps } from '../models/over-ask.model';
import { overAskFlowRemainingSecondsSelector, overAskStateSelector } from '../selectors';

export const overAskBetsSelector = createSelector(overAskStateSelector, (state) => ({
    bets: state.bets,
    offerChanged: state.reviewState.offerChanged,
    offerId: state.offerId,
    decisionSource: state.decisionSource,
}));

/**
 * We need this base component to subscribe to state changes only when OverAsk overlay is opened
 */
@Component({
    template: '',
    standalone: false,
})
export class BetslipOverAskContentBaseComponent implements OnInit, OnDestroy {
    @Input() overAskFlowState: OverAskFlowState;
    overFlowStates = OverAskFlowState;

    remainingSeconds: number;
    pickListProps: IBetslipOverAskPickListProps;
    summaryProps: IBetslipOverAskSummaryComponentProps;
    offerId: string;
    defaultOddsDisplayFormat = OddsDisplayFormat.EU;
    oddsDisplayFormat: OddsDisplayFormat;

    overAskStateSubscription: Subscription;
    overAskRemainingSecondsSubscription: Subscription;
    oddsDisplayFormatSubscription: Subscription;
    decisionSource?: DecisionSource;

    constructor(
        private store: Store<IBetslipRootState>,
        private changeDetector: ChangeDetectorRef,
        private userStateService: UserStateService,
    ) {}

    ngOnInit(): void {
        this.overAskStateSubscription = this.store.select(overAskBetsSelector).subscribe((state) => {
            this.pickListProps = {
                overAskBets: state.bets,
            };
            this.summaryProps = {
                bets: state.bets,
                hasOfferChanges: state.offerChanged,
            };
            this.offerId = state.offerId;
            this.decisionSource = state.decisionSource;
            this.changeDetector.markForCheck();
        });

        this.overAskRemainingSecondsSubscription = this.store.select(overAskFlowRemainingSecondsSelector).subscribe((remainingSeconds) => {
            this.remainingSeconds = remainingSeconds;
            this.changeDetector.markForCheck();
        });
        this.oddsDisplayFormatSubscription = this.userStateService.userState$().subscribe((state) => {
            this.oddsDisplayFormat = state.oddsFormat || this.defaultOddsDisplayFormat;
            this.changeDetector.markForCheck();
        });
    }

    ngOnDestroy(): void {
        this.overAskStateSubscription?.unsubscribe();
        this.overAskRemainingSecondsSubscription?.unsubscribe();
        this.oddsDisplayFormatSubscription?.unsubscribe();
    }

    get isPendingState(): boolean {
        return this.overAskFlowState === OverAskFlowState.Pending;
    }

    get isReviewState(): boolean {
        return this.overAskFlowState === OverAskFlowState.Review;
    }
}
